import Icon from '../components/Icon.vue'

Icon.register({
  wind: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M156.7 256c48.7 0 92.3 35 98.4 83.4 7.5 58.5-38.1 108.6-95.2 108.6-46.6 0-85.6-33.5-94.2-77.6-1.8-9.6 6.1-18.4 15.9-18.4h32.8c6.6 0 13.1 3.8 15.2 10.1 4.3 12.7 16.3 21.9 30.4 21.9 19.5 0 34.9-17.4 31.6-37.4-2.6-15.7-17.5-26.6-33.4-26.6h-142.2c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h140.7zM16 224c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h334.2c16 0 30.8-10.9 33.4-26.6 3.3-20-12.2-37.4-31.6-37.4-14.1 0-26.1 9.2-30.4 21.9-2.1 6.3-8.5 10.1-15.2 10.1h-32.8c-9.7 0-17.7-8.7-15.8-18.3 9.8-50.6 59.5-87.1 114.9-75.5 36.2 7.6 65.5 36.9 73.1 73.1 13 61.9-34.1 116.7-93.8 116.7h-336zM400 256c70.5 0 126 65.5 108.9 138.7-9.6 41.1-43.5 74-84.7 82.7-58.9 12.5-111.6-21.7-129.4-72.3-3.7-10.3 4.4-21.1 15.3-21.1h33.8c5.8 0 11.6 2.6 14.5 7.6 8.3 14.5 23.7 24.4 41.6 24.4 26.5 0 48-21.5 48-48s-21.5-48-48-48h-116.5c-6.6-25.2-20.5-47.4-39.8-64h156.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wind.js
// module id = 2110
// module chunks = 0